import React from 'react';
import Card from '../../Components/Card/Card';
import CardHeader from '../../Components/Card/CardHeader';
import CardBody from '../../Components/Card/CardBody';
import Grid from '@material-ui/core/Grid';
import { Paper } from '@material-ui/core';
import 'jquery-confirm';

export default function Referrals(props) {
    if (!props.penalistData.hasOwnProperty('data') || props.penalistData.data === null) return <></>;
    const { referrals } = props.penalistData.data;
    return (
        <Card>
            <CardHeader color="info">
                <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-center">Referrals</h4>
                </div>
            </CardHeader>
            <CardBody>
                <Grid container spacing={6}>
                    <Grid item xs={12} sm={6}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Total Referrals : <br />{referrals.totalCount}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={props.classes.paper} elevation={3}>
                            Completed Referrals : <br />{referrals.approvedCount}
                        </Paper>
                    </Grid>
                </Grid>
            </CardBody>
        </Card>
    )
}